import { useState } from "react"

export default function Toggle(props: { value: boolean, onChange: () => void }) {
    return <div className={"transition-colors rounded-full w-12 h-7 cursor-pointer relative " + (props.value ? 'bg-green-700' : 'bg-slate-500')} onClick={() => props.onChange()}>
        <div className="absolute top-[50%]">
            <div className={"rounded-full w-5 h-5 bg-white top-[-0.625rem] absolute transition-all " + (props.value ? 'left-[1.55rem]' : 'left-[0.2rem]')}></div>
        </div>
    </div>
}